/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as managementGroupV1 from "./keyapis_access_management_group_v1.pb"

/**
 * Сервис реализует функционал управления шаблонами пользовательских групп
 */

/**
 * Сервис управления шаблонами пользовательских групп
 */
export class GroupTemplateServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения шаблона группы.
   * Метод доступен для: admin, service, bti, seller
   */
  GetGroupTemplate = (req: GetGroupTemplateRequestDto, init?: RequestInit): Promise<GetGroupTemplateResponseDto> => {
    return fm.request<GetGroupTemplateRequestDto, GetGroupTemplateResponseDto>(`${this.host}/access_management/api/v1/group_template/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка шаблонов групп.
   * Метод доступен для: admin, service, bti, seller
   */
  GetGroupTemplateList = (req?: GetGroupTemplateListRequestDto, init?: RequestInit): Promise<GetGroupTemplateListResponseDto[]> => {
    return fm.list<GetGroupTemplateListRequestDto, GetGroupTemplateListResponseDto>(`${this.host}/access_management/api/v1/group_template/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества шаблонов групп.
   * Метод доступен для: admin, service, bti, seller
   */
  GetGroupTemplateCount = (req?: GetGroupTemplateCountRequestDto, init?: RequestInit): Promise<GetGroupTemplateCountResponseDto> => {
    return fm.request<GetGroupTemplateCountRequestDto, GetGroupTemplateCountResponseDto>(`${this.host}/access_management/api/v1/group_template/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения шаблона группы.
   * Поддерживает создание и обновление как UPSERT по GroupTemplate.id.
   * Метод доступен для: admin, service
   */
  PostGroupTemplate = (req: PostGroupTemplateRequestDto, init?: RequestInit): Promise<PostGroupTemplateResponseDto> => {
    return fm.request<PostGroupTemplateRequestDto, PostGroupTemplateResponseDto>(`${this.host}/access_management/api/v1/group_template`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления шаблона группы.
   * Проставляет дату удаления GroupTemplate.deleted_at.
   * Метод доступен для: admin, service
   */
  DeleteGroupTemplate = (req: DeleteGroupTemplateRequestDto, init?: RequestInit): Promise<DeleteGroupTemplateResponseDto> => {
    return fm.request<DeleteGroupTemplateRequestDto, DeleteGroupTemplateResponseDto>(`${this.host}/access_management/api/v1/group_template/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей шаблонов групп и группы пользователя.
   * Метод доступен для: admin, service
   */
  GetGroupTemplateGroupList = (req?: GetGroupTemplateGroupListRequestDto, init?: RequestInit): Promise<GetGroupTemplateGroupListResponseDto[]> => {
    return fm.list<GetGroupTemplateGroupListRequestDto, GetGroupTemplateGroupListResponseDto>(`${this.host}/access_management/api/v1/group_template/group/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей шаблонов групп и группы пользователя.
   * Метод доступен для: admin, service
   */
  GetGroupTemplateGroupCount = (req?: GetGroupTemplateGroupCountRequestDto, init?: RequestInit): Promise<GetGroupTemplateGroupCountResponseDto> => {
    return fm.request<GetGroupTemplateGroupCountRequestDto, GetGroupTemplateGroupCountResponseDto>(`${this.host}/access_management/api/v1/group_template/group/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения связей шаблонов групп и группы пользователя.
   * Метод доступен для: admin, service
   */
  PutGroupTemplateGroupAttach = (req: PutGroupTemplateGroupAttachRequestDto, init?: RequestInit): Promise<PutGroupTemplateGroupAttachResponseDto> => {
    return fm.request<PutGroupTemplateGroupAttachRequestDto, PutGroupTemplateGroupAttachResponseDto>(`${this.host}/access_management/api/v1/group_template/${encodeURIComponent(req.groupTemplateGroup.groupTemplateId)}/group/${encodeURIComponent(req.groupTemplateGroup.groupId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связей шаблонов групп и группы пользователя.
   * Метод доступен для: admin, service
   */
  PutGroupTemplateGroupDetach = (req: PutGroupTemplateGroupDetachRequestDto, init?: RequestInit): Promise<PutGroupTemplateGroupDetachResponseDto> => {
    return fm.request<PutGroupTemplateGroupDetachRequestDto, PutGroupTemplateGroupDetachResponseDto>(`${this.host}/access_management/api/v1/group_template/${encodeURIComponent(req.groupTemplateGroup.groupTemplateId)}/group/${encodeURIComponent(req.groupTemplateGroup.groupId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки
 */
export enum GroupTemplateGroupPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type GroupTemplateGroupPagingDirectionTypeResponseEnum = keyof typeof GroupTemplateGroupPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type GroupTemplateGroupPagingDirectionTypeRequestEnum = Exclude<GroupTemplateGroupPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum GroupTemplateGroupPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору группы пользователя
   */
  GROUP_ID = "GROUP_ID",
  /**
   * По шаблону групп
   */
  GROUP_TEMPLATE_ID = "GROUP_TEMPLATE_ID",
}
/**
 * Справочник типов сортировки
 */
export type GroupTemplateGroupPagingOrderByTypeResponseEnum = keyof typeof GroupTemplateGroupPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type GroupTemplateGroupPagingOrderByTypeRequestEnum = Exclude<GroupTemplateGroupPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum GroupTemplatePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type GroupTemplatePagingDirectionTypeResponseEnum = keyof typeof GroupTemplatePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type GroupTemplatePagingDirectionTypeRequestEnum = Exclude<GroupTemplatePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum GroupTemplatePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
}
/**
 * Справочник типов значений сортировки.
 */
export type GroupTemplatePagingOrderByTypeResponseEnum = keyof typeof GroupTemplatePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type GroupTemplatePagingOrderByTypeRequestEnum = Exclude<GroupTemplatePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления шаблона группы
 */
export type DeleteGroupTemplateRequestDto = {
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления группы
 */
export type DeleteGroupTemplateResponseDto = {
}
/**
 * Запрос получения количества шаблонов групп
 */
export type GetGroupTemplateCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: GroupTemplateFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества шаблонов групп
 */
export type GetGroupTemplateCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего шаблонов групп
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetGroupTemplateCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества шаблонов групп
 */
export type GetGroupTemplateCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества шаблонов групп
 */
export type GetGroupTemplateCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества связей шаблонов групп и группы пользователя
 */
export type GetGroupTemplateGroupCountRequestDto = {
  /**
   * Фильтр связей шаблонов групп и группы пользователя
   */
  filter?: GroupTemplateGroupFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей шаблонов групп и группы пользователя
 */
export type GetGroupTemplateGroupCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего связей шаблонов групп и группы пользователя
   */
  readonly data: number
}>
/**
 * Запрос получения списка
 */
export type GetGroupTemplateGroupListRequestDto = {
  /**
   * Фильтр связей шаблонов групп и группы пользователя
   */
  filter?: GroupTemplateGroupFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: GroupTemplateGroupPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей шаблонов групп и группы пользователя
 */
export type GetGroupTemplateGroupListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связь шаблона группы и группы пользователя
   */
  readonly data: GroupTemplateGroupResponseDto
}>
/**
 * Запрос получения списка шаблонов групп
 */
export type GetGroupTemplateListRequestDto = {
  /**
   * Фильтр
   */
  filter?: GroupTemplateFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: GroupTemplatePagingRequestDto
}>
/**
 * Ответ на запрос получения списка шаблонов групп
 */
export type GetGroupTemplateListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон группы
   */
  readonly data: GroupTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: GetGroupTemplateListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка шаблонов групп
 */
export type GetGroupTemplateListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка шаблонов групп
 */
export type GetGroupTemplateListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения шаблона группы
 */
export type GetGroupTemplateRequestDto = {
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения шаблона группы
 */
export type GetGroupTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон группы
   */
  readonly data: GroupTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: GetGroupTemplateResponseErrorDto
}>
/**
 * Ошибка запроса получения шаблона группы
 */
export type GetGroupTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения шаблона группы
 */
export type GetGroupTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorResponseDto
}>
/**
 * Шаблон группы пользователей
 */
export type GroupTemplateRequestDto = {
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  id?: string
  /**
   * Наименование шаблона группы.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Суффикс наименования группы.
   * # Диапазон: 3..256
   */
  groupTitleSuffix: string
  /**
   * Описание шаблона группы.
   * # Диапазон: 3..256
   */
  description?: string
  /**
   * Массив атрибутов группы.
   * Эти атрибуты назначены пользователям, которые принадлежат группе.
   * # Диапазон: 0..100
   */
  claims?: managementGroupV1.ClaimRequestDto[]
  /**
   * Требования, означающие принадлежность пользователя к данной группе.
   * Пользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.
   * # Диапазон: 0..10
   */
  requirements?: managementGroupV1.ClaimRequestDto[]
  /**
   * Теги шаблона группы.
   * # Диапазон: 0..10
   */
  tags?: string[]
}
/**
 * Шаблон группы пользователей
 */
export type GroupTemplateResponseDto = {
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  id: string
  /**
   * Наименование шаблона группы.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Суффикс наименования группы.
   * # Диапазон: 3..256
   */
  groupTitleSuffix: string
  /**
   * Описание шаблона группы.
   * # Диапазон: 3..256
   */
  description: string
  /**
   * Массив атрибутов группы.
   * Эти атрибуты назначены пользователям, которые принадлежат группе.
   * # Диапазон: 0..100
   */
  claims: managementGroupV1.ClaimResponseDto[]
  /**
   * Требования, означающие принадлежность пользователя к данной группе.
   * Пользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.
   * # Диапазон: 0..10
   */
  requirements: managementGroupV1.ClaimResponseDto[]
  /**
   * Теги шаблона группы.
   * # Диапазон: 0..10
   */
  tags: string[]
}
/**
 * Фильтр шаблонов групп.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type GroupTemplateFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text?: string
  /**
   * По тегам.
   * # Диапазон: 0..10
   */
  tags?: string[]
}
/**
 * Фильтр шаблонов групп.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type GroupTemplateFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text: string
  /**
   * По тегам.
   * # Диапазон: 0..10
   */
  tags: string[]
}
/**
 * Связка шаблона группы и группы пользователя.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к шаблону группы
 */
export type GroupTemplateGroupRequestDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  groupTemplateId: string
}
/**
 * Связка шаблона группы и группы пользователя.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к шаблону группы
 */
export type GroupTemplateGroupResponseDto = {
  /**
   * Идентификатор группы.
   * # Тип: Guid
   */
  groupId: string
  /**
   * Идентификатор шаблона группы.
   * # Тип: Guid
   */
  groupTemplateId: string
}
/**
 * Фильтр для запроса связей шаблона группы и группы пользователя.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type GroupTemplateGroupFilterRequestDto = {
  /**
   * По Идентификатору группы пользователя
   */
  groupIds?: string[]
  /**
   * По шаблону группы
   */
  groupTemplateIds?: string[]
}
/**
 * Фильтр для запроса связей шаблона группы и группы пользователя.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type GroupTemplateGroupFilterResponseDto = {
  /**
   * По Идентификатору группы пользователя
   */
  groupIds: string[]
  /**
   * По шаблону группы
   */
  groupTemplateIds: string[]
}
/**
 * Пагинация шаблонов групп и группы пользователя
 */
export type GroupTemplateGroupPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: GroupTemplateGroupPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: GroupTemplateGroupPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация шаблонов групп и группы пользователя
 */
export type GroupTemplateGroupPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: GroupTemplateGroupPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: GroupTemplateGroupPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Пагинация шаблонов групп
 */
export type GroupTemplatePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType?: GroupTemplatePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: GroupTemplatePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация шаблонов групп
 */
export type GroupTemplatePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType: GroupTemplatePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: GroupTemplatePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос сохранения шаблона группы
 */
export type PostGroupTemplateRequestDto = {
  /**
   * Шаблон группы
   */
  data: GroupTemplateRequestDto
}
/**
 * Ответ на запрос сохранения шаблона группы
 */
export type PostGroupTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон группы
   */
  readonly data: GroupTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: PostGroupTemplateResponseErrorDto
}>
/**
 * Ошибка запроса сохранения шаблона группы
 */
export type PostGroupTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения шаблона группы
 */
export type PostGroupTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: managementGroupV1.ValidationErrorResponseDto
}>
/**
 * Запрос сохранения связей шаблона группы и группы пользователя
 */
export type PutGroupTemplateGroupAttachRequestDto = {
  /**
   * Связь шаблона группы и группы пользователя
   */
  groupTemplateGroup: GroupTemplateGroupRequestDto
}
/**
 * Ответ на запрос сохранения связи шаблона группы и группы пользователя
 */
export type PutGroupTemplateGroupAttachResponseDto = {
}
/**
 * Запрос удаления связей шаблона группы и группы пользователя
 */
export type PutGroupTemplateGroupDetachRequestDto = {
  /**
   * Связь шаблона группы и группы пользователя
   */
  groupTemplateGroup: GroupTemplateGroupRequestDto
}
/**
 * Ответ на запрос удаления связи шаблона группы и группы пользователя
 */
export type PutGroupTemplateGroupDetachResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления шаблона группы
   */
  "DeleteGroupTemplateRequest": {
    "kind": "class",
    "text": "Запрос удаления шаблона группы",
    "fields": {
      /**
       * Идентификатор шаблона группы.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления группы
   */
  "DeleteGroupTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления группы",
  },
  /**
   * Запрос получения количества шаблонов групп
   */
  "GetGroupTemplateCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества шаблонов групп",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "GroupTemplateFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества шаблонов групп
   */
  "GetGroupTemplateCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества шаблонов групп",
    "fields": {
      /**
       * Всего шаблонов групп
       */
      "data": {
        "type": "int32",
        "text": "Всего шаблонов групп",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupTemplateCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества шаблонов групп
   */
  "GetGroupTemplateCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества шаблонов групп",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества связей шаблонов групп и группы пользователя
   */
  "GetGroupTemplateGroupCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей шаблонов групп и группы пользователя",
    "fields": {
      /**
       * Фильтр связей шаблонов групп и группы пользователя
       */
      "filter": {
        "type": "GroupTemplateGroupFilter",
        "text": "Фильтр связей шаблонов групп и группы пользователя",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей шаблонов групп и группы пользователя
   */
  "GetGroupTemplateGroupCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей шаблонов групп и группы пользователя",
    "fields": {
      /**
       * Всего связей шаблонов групп и группы пользователя
       */
      "data": {
        "type": "int32",
        "text": "Всего связей шаблонов групп и группы пользователя",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetGroupTemplateGroupListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр связей шаблонов групп и группы пользователя
       */
      "filter": {
        "type": "GroupTemplateGroupFilter",
        "text": "Фильтр связей шаблонов групп и группы пользователя",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "GroupTemplateGroupPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей шаблонов групп и группы пользователя
   */
  "GetGroupTemplateGroupListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей шаблонов групп и группы пользователя",
    "fields": {
      /**
       * Связь шаблона группы и группы пользователя
       */
      "data": {
        "type": "GroupTemplateGroup",
        "text": "Связь шаблона группы и группы пользователя",
      },
    },
  },
  /**
   * Запрос получения списка шаблонов групп
   */
  "GetGroupTemplateListRequest": {
    "kind": "class",
    "text": "Запрос получения списка шаблонов групп",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "GroupTemplateFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "GroupTemplatePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка шаблонов групп
   */
  "GetGroupTemplateListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка шаблонов групп",
    "fields": {
      /**
       * Шаблон группы
       */
      "data": {
        "type": "GroupTemplate",
        "text": "Шаблон группы",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupTemplateListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка шаблонов групп
   */
  "GetGroupTemplateListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка шаблонов групп",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения шаблона группы
   */
  "GetGroupTemplateRequest": {
    "kind": "class",
    "text": "Запрос получения шаблона группы",
    "fields": {
      /**
       * Идентификатор шаблона группы.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения шаблона группы
   */
  "GetGroupTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения шаблона группы",
    "fields": {
      /**
       * Шаблон группы
       */
      "data": {
        "type": "GroupTemplate",
        "text": "Шаблон группы",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetGroupTemplateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения шаблона группы
   */
  "GetGroupTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения шаблона группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Шаблон группы пользователей
   */
  "GroupTemplate": {
    "kind": "class",
    "text": "Шаблон группы пользователей",
    "fields": {
      /**
       * Идентификатор шаблона группы.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона группы.\n# Тип: Guid",
      },
      /**
       * Наименование шаблона группы.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование шаблона группы.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Суффикс наименования группы.
       * # Диапазон: 3..256
       */
      "groupTitleSuffix": {
        "type": "string",
        "text": "Суффикс наименования группы.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Описание шаблона группы.
       * # Диапазон: 3..256
       */
      "description": {
        "type": "string",
        "text": "Описание шаблона группы.\n# Диапазон: 3..256",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Массив атрибутов группы.
       * Эти атрибуты назначены пользователям, которые принадлежат группе.
       * # Диапазон: 0..100
       */
      "claims": {
        "type": "Claim",
        "text": "Массив атрибутов группы.\nЭти атрибуты назначены пользователям, которые принадлежат группе.\n# Диапазон: 0..100",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Требования, означающие принадлежность пользователя к данной группе.
       * Пользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.
       * # Диапазон: 0..10
       */
      "requirements": {
        "type": "Claim",
        "text": "Требования, означающие принадлежность пользователя к данной группе.\nПользователь принадлежит группе, если все атрибуты требований группы присутствуют у пользователя и имеют те же значения.\n# Диапазон: 0..10",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
      /**
       * Теги шаблона группы.
       * # Диапазон: 0..10
       */
      "tags": {
        "type": "string",
        "text": "Теги шаблона группы.\n# Диапазон: 0..10",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
    },
  },
  /**
   * Фильтр шаблонов групп.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "GroupTemplateFilter": {
    "kind": "class",
    "text": "Фильтр шаблонов групп.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование
       */
      "text": {
        "type": "string",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По тегам.
       * # Диапазон: 0..10
       */
      "tags": {
        "type": "string",
        "text": "По тегам.\n# Диапазон: 0..10",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
    },
  },
  /**
   * Связка шаблона группы и группы пользователя.
   * Задает область ресурсов (resource scope), доступную пользователю.
   * Используется для контроля доступа к шаблону группы
   */
  "GroupTemplateGroup": {
    "kind": "class",
    "text": "Связка шаблона группы и группы пользователя.\nЗадает область ресурсов (resource scope), доступную пользователю.\nИспользуется для контроля доступа к шаблону группы",
    "fields": {
      /**
       * Идентификатор группы.
       * # Тип: Guid
       */
      "groupId": {
        "type": "string",
        "text": "Идентификатор группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор шаблона группы.
       * # Тип: Guid
       */
      "groupTemplateId": {
        "type": "string",
        "text": "Идентификатор шаблона группы.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса связей шаблона группы и группы пользователя.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "GroupTemplateGroupFilter": {
    "kind": "class",
    "text": "Фильтр для запроса связей шаблона группы и группы пользователя.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификатору группы пользователя
       */
      "groupIds": {
        "type": "string",
        "text": "По Идентификатору группы пользователя",
      },
      /**
       * По шаблону группы
       */
      "groupTemplateIds": {
        "type": "string",
        "text": "По шаблону группы",
      },
    },
  },
  /**
   * Пагинация шаблонов групп и группы пользователя
   */
  "GroupTemplateGroupPaging": {
    "kind": "class",
    "text": "Пагинация шаблонов групп и группы пользователя",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "GroupTemplateGroupPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "GroupTemplateGroupPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Пагинация шаблонов групп
   */
  "GroupTemplatePaging": {
    "kind": "class",
    "text": "Пагинация шаблонов групп",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ID
       */
      "orderByType": {
        "type": "GroupTemplatePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "GroupTemplatePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос сохранения шаблона группы
   */
  "PostGroupTemplateRequest": {
    "kind": "class",
    "text": "Запрос сохранения шаблона группы",
    "fields": {
      /**
       * Шаблон группы
       */
      "data": {
        "type": "GroupTemplate",
        "text": "Шаблон группы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения шаблона группы
   */
  "PostGroupTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения шаблона группы",
    "fields": {
      /**
       * Шаблон группы
       */
      "data": {
        "type": "GroupTemplate",
        "text": "Шаблон группы",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostGroupTemplateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения шаблона группы
   */
  "PostGroupTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения шаблона группы",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения связей шаблона группы и группы пользователя
   */
  "PutGroupTemplateGroupAttachRequest": {
    "kind": "class",
    "text": "Запрос сохранения связей шаблона группы и группы пользователя",
    "fields": {
      /**
       * Связь шаблона группы и группы пользователя
       */
      "groupTemplateGroup": {
        "type": "GroupTemplateGroup",
        "text": "Связь шаблона группы и группы пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи шаблона группы и группы пользователя
   */
  "PutGroupTemplateGroupAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи шаблона группы и группы пользователя",
  },
  /**
   * Запрос удаления связей шаблона группы и группы пользователя
   */
  "PutGroupTemplateGroupDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связей шаблона группы и группы пользователя",
    "fields": {
      /**
       * Связь шаблона группы и группы пользователя
       */
      "groupTemplateGroup": {
        "type": "GroupTemplateGroup",
        "text": "Связь шаблона группы и группы пользователя",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи шаблона группы и группы пользователя
   */
  "PutGroupTemplateGroupDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи шаблона группы и группы пользователя",
  },
  /**
   * Справочник типов направлений сортировки
   */
  "GroupTemplateGroupPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "GroupTemplateGroupPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору группы пользователя
       */
      "GROUP_ID": {
        "i": 1,
        "text": "По Идентификатору группы пользователя",
      },
      /**
       * По шаблону групп
       */
      "GROUP_TEMPLATE_ID": {
        "i": 2,
        "text": "По шаблону групп",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "GroupTemplatePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "GroupTemplatePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
    },
  },
}